import { Button } from "antd";
import styled from "styled-components";


export const StyledLayout = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  font-size: 20px;
  margin-bottom: 10px;
  margin-left: 20px;
  color: #212529;
`;

export const GroupContainer = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  min-width: 300px;
  padding: 5px 10px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  transition: background-color 0.3s ease;

  &:hover {
    cursor: pointer;
    background-color: #f0f0f0;
    border: 1px solid #d9d9d9;
  }

  ::-webkit-scrollbar {
    width: 0;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-track:hover {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(212, 212, 215);
    border-radius: 5px;
    width: 0;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(190, 190, 193);
  }

  &:hover {
    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-thumb {
      width: 2px;
    }
  }
`;

export const GroupHeader = styled.div`
  padding: 10px 5px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: #212529;
`;

export const PermissionList = styled.div`
  height: calc(100% - 32px);
  padding: 0 5px 16px 0px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ItemContainer = styled.div`
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &.dragging {
    background: #f8f9fa;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0; /* Needed for text-overflow to work properly */
`;

export const DragHandle = styled.div`
  cursor: grab;
  color: #adb5bd;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #f8f9fa;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e9ecef;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const EditInput = styled.input`
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  width: 200px;

  &:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const ActionButton = styled(Button)`
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;

  &:hover {
    color: #dc3545;
    background: #f8f9fa;
  }
`;

export const StyledLists = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: calc(100% - 32px);
  padding: 16px;
`;

export const Container = styled.div<any>`
  display: flex;
  gap: 16px;
  height: calc(100dvh - 130px);
  overflow-x: scroll;
/* 
  @media (max-width: 1435px) {
    height: calc(100vh - 193px);
  }

  @media (max-width: 700px) {
    height: calc(100vh - 305px);
  } */
`;

export const StyledButton = styled(Button)` 
padding: 20px;
`;

export const PermissionConfigName = styled.div`
    width: 100%;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
`